import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
// import Input from "../../../Components/Utils/Input";

// import BasicInput from "../../../Components/Utils/BasicInput";
// import Input from "../../../Components/Utils/Input";

// import Input from "../../Components/Utils/Input";
// import Button from "../../Components/Utils/Button";
// import BasicInput from "../../../Components/Utils/BasicInput";
// import moment from "moment";
import { useParams } from "react-router-dom";
import messageSlice from "../../../Redux/MessageSlice";
import { getAcademicSessionsAsync } from "../../../Redux/MasterSlice";
import BaseApi from "../../../Http/BaseApi";
import PageTitle from "../../../Components/Common/PageTitle";
import Alert from "../../../Components/Utils/Alert";
// import CustomSelect from "../../../Components/Utils/CustomSelect";
import { ThreeDots } from "react-loader-spinner";
import Button from "../../../Components/Utils/Button";
import tableToCSV from "../../../Components/Utils/TableToCSV";
import { getCostCentersAsync } from "../../../Redux/BudgetSlice";
import { useNavigate } from "react-router-dom";

export default function BudgetByCenter() {
  const dispatch = useDispatch();
  const { costCenter_id } = useParams();
  const { accBudgetFormId } = useParams();
  const navigate = useNavigate();

  // const [initialValues, setInitialValues] = useState();
  const [loading, setLoading] = useState(false);
  const [assignedHeads, setAssignedHeads] = useState([]);

  const [budgets, setBudgets] = useState([]);
  const [budgetForm, setBudgetForm] = useState();
  const [budgetMasters, setBudgetMasters] = useState([]);
  const master = useSelector((state) => state.master);
  const budget = useSelector((state) => state.budget);
  const academicSessions = [...master.academicSessions];
  const { message } = useSelector((state) => state.message);
  const costCenters = [...budget.costCenters];

  // const [formRole, setFormRole] = useState("add");

  //   const dispatch = useDispatch();
  useEffect(() => {
    dispatch(messageSlice.actions.clearMessage());
    // if (!can("View Attendance Sheet")) {
    //   navigate(`/not-found`);
    // }

    // dispatch(messageSlice.actions.clearMessage());
    if (academicSessions.length === 0) {
      dispatch(getAcademicSessionsAsync());
    }
    if (assignedHeads.length === 0) {
      // getAssignedHeads();
    }
    // getOpenBudgets();

    if (costCenters.length === 0) {
      dispatch(getCostCentersAsync());
    }
    // setInitialValues({
    //   academic_session_id: "",
    //   acc_budget_form_id: accBudgetFormId,
    // });

    async function getData() {
      if (budgetMasters.length === 0) {
        var response = await BaseApi().get(`budget-masters`);
        setBudgetMasters(response.data);
      }
      if (response.data?.length > 0) {
        let _budgetMaster = response.data.find(
          (bm) => bm.id == accBudgetFormId
        );
        console.log(_budgetMaster);
        setBudgetForm(_budgetMaster);
        await getAssignedHeads(_budgetMaster?.acc_budget_master_id);
        await callBudgets(
          accBudgetFormId,
          costCenter_id,
          _budgetMaster?.academic_session_id
        );
      }
    }

    getData();

    // dispatch(getOldStudentsAsync());
  }, [dispatch]);

  let currentSession = academicSessions.find((e) => {
    return e.id == budgetForm?.academic_session_id;
  });

  let lastSession = academicSessions.find((as) => {
    return as.serial == currentSession?.serial - 1;
  });

  let last2Session = academicSessions.find((as) => {
    return as.serial == currentSession?.serial - 2;
  });
  const getAssignedHeads = async (acc_budget_master_id) => {
    await BaseApi()
      .get(
        `get-assigned-heads?acc_budget_master_id=${acc_budget_master_id}&cost_center_id=${costCenter_id}`
      )
      .then(async (response) => {
        let heads = response.data;

        await heads.map((head) => {
          if (head.parent.parent) {
            if (!heads.some((h) => h.id == head.parent.parent.id))
              heads.push(head.parent.parent);
            delete head.parent.parent;
          }
          if (head.parent) {
            if (!heads.some((h) => h.id == head.parent.id))
              heads.push(head.parent);
            delete head.parent;
          }
        });

        console.log("Flat Heads", heads);
        setAssignedHeads(heads);
      });
  };

  // const getOpenBudgets = async () => {
  //   await BaseApi()
  //     .get(`get-open-budgets`)
  //     .then((response) => {
  //       console.log(response.data);
  //       setOpenBudgets(response.data);
  //     })
  //     .catch(() => {
  //       setLoading(false);
  //     });
  // };

  const callBudgets = async (
    acc_budget_form_id,
    costCenter_id,
    academic_session_id
  ) => {
    setLoading(true);
    console.log(academic_session_id);
    const _budgets = await BaseApi().get(`budgets`, {
      params: {
        acc_budget_form_id: acc_budget_form_id,
        cost_center_id: costCenter_id,
      },
    });

    setBudgets(_budgets.data);

    // setInitialValues({
    //   acc_budget_form_id: acc_budget_form_id,
    //   academic_session_id: academic_session_id,
    // });
    setLoading(false);
  };

  return (
    <>
      <div className="py-2">
        <div className="mx-auto container min-h-screen bg-white dark:bg-gray-800 shadow rounded">
          <div className="w-full px-5   ">
            <PageTitle name="Budget Details of:" />
            <h2 className="text-xl ml-5">
              Cost/Revenue Center{" "}
              {costCenters.find((c) => c.id == costCenter_id)?.name}
            </h2>

            {message && <Alert message={message} />}

            <div className=" py-5 grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 pt-6 gap-8">
              {/* <CustomSelect
                    options={openBudgets}
                    name="acc_budget_form_id"
                    label="Select Budget Master"
                    isSearchable={true}
                    getOptionValue={(option) => `${option}`}
                    getOptionLabel={(option) =>
                      `${option.budget_master?.name} - ${
                        option.academic_session?.label
                      }  | Last Date:  ${moment(option.to_date).format(
                        "Do MMM YYYY"
                      )} `
                    }
                    onChange={async (selectedOption) => {
                      console.log(selectedOption);
                      formikRef.current?.setFieldValue(
                        "acc_budget_form_id",
                        selectedOption.id
                      );

                      formikRef.current?.setFieldValue(
                        "academic_session_id",
                        selectedOption.academic_session_id
                      );
                      await getAssignedHeads(
                        selectedOption.acc_budget_master_id
                      );

                      callBudgets(selectedOption);
                    }}
                  /> */}
            </div>
            {loading == true && (
              <>
                <div className="flex">
                  <span className="m-auto">
                    <ThreeDots
                      height="100"
                      width="100"
                      color="grey"
                      ariaLabel="loading"
                    />
                  </span>
                </div>
              </>
            )}
            {budgets?.length > 0 && (
              <>
                <h1 className="my-5 font-medium text-xl">
                  {" "}
                  Receipts Side:
                  <Button
                    classNames="float-right mr-5 bg-blue-600 hover:bg-blue-700 focus:ring-blue-500"
                    value={"Edit"}
                    onClick={() => {
                      navigate(
                        `/budget-edit/receipt/${costCenter_id}/${accBudgetFormId}`
                      );
                    }}
                    icon={"PencilIcon"}
                    type="button"
                  />
                  <Button
                    classNames="float-right mr-5 bg-blue-600 hover:bg-blue-700 focus:ring-blue-500"
                    value={"Download CSV"}
                    onClick={() => tableToCSV("datatableReceipt")}
                    icon={"DownloadIcon"}
                    type="button"
                  />
                </h1>

                <table
                  id="datatableReceipt"
                  className="min-w-full mt-5 bg-white dark:bg-gray-800"
                >
                  <thead>
                    <tr className="w-full h-16 border-gray-300 dark:border-gray-200 border-b py-8">
                      <th className="table-head"> Ledger Code</th>
                      <th className="table-head"> Heads</th>
                      <th className="table-head">
                        {" "}
                        Actual{" "}
                        {
                          academicSessions.find((as) => {
                            return as.serial == currentSession?.serial - 2;
                          })?.label
                        }{" "}
                        <small className="text-gray-400 text-xs">
                          <br />
                          Amount in Rs.
                        </small>
                      </th>
                      <th className="table-head">
                        {" "}
                        Budget{" "}
                        {
                          academicSessions.find((as) => {
                            return as.serial == currentSession?.serial - 1;
                          })?.label
                        }{" "}
                        <small className="text-gray-400 text-xs">
                          <br />
                          Amount in Rs.
                        </small>
                      </th>
                      <th className="table-head">
                        {" "}
                        Revised{" "}
                        {
                          academicSessions.find((as) => {
                            return as.serial == currentSession?.serial - 1;
                          })?.label
                        }{" "}
                        <small className="text-gray-400 text-xs">
                          <br />
                          Amount in Rs.
                        </small>
                      </th>
                      <th className="table-head">
                        {" "}
                        Budget {currentSession?.label}{" "}
                        <small className="text-gray-400 text-xs">
                          <br />
                          Amount in Rs.
                        </small>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {assignedHeads
                      .filter(
                        (ah) => ah.acc_payment_head_id == null && ah.type == 1
                      )
                      ?.map((head) => {
                        return (
                          <>
                            {assignedHeads.some(
                              (detail1) =>
                                detail1.acc_payment_head_id == head.id
                            ) ? (
                              <tr className="h-12 border-gray-300 dark:border-gray-200 border-b">
                                <td className="  table-data font-bold">
                                  {head.code}
                                </td>
                                <td
                                  colSpan="5"
                                  className="  table-data font-bold"
                                >
                                  {head.name}
                                </td>
                              </tr>
                            ) : (
                              dataRowReceipt(
                                assignedHeads.indexOf(head),
                                head,
                                budgets,
                                last2Session,
                                lastSession,
                                currentSession
                              )
                            )}

                            {assignedHeads
                              .filter(
                                (detail1) =>
                                  detail1.acc_payment_head_id == head.id
                              )
                              ?.map((child) => {
                                return (
                                  <>
                                    {assignedHeads.some(
                                      (detail2) =>
                                        detail2.acc_payment_head_id == child.id
                                    ) ? (
                                      <tr className="h-12 border-gray-300 dark:border-gray-200 border-b">
                                        <td className="font-medium table-data">
                                          {child.code}
                                        </td>
                                        <td
                                          colSpan="5"
                                          className="font-medium table-data"
                                        >
                                          {child.name}
                                        </td>
                                      </tr>
                                    ) : (
                                      dataRowReceipt(
                                        assignedHeads.indexOf(child),
                                        child,
                                        budgets,
                                        last2Session,
                                        lastSession,
                                        currentSession
                                      )
                                    )}
                                    {assignedHeads
                                      .filter(
                                        (detail2) =>
                                          detail2.acc_payment_head_id ==
                                          child.id
                                      )
                                      ?.map((child1) => {
                                        return (
                                          <>
                                            {dataRowReceipt(
                                              assignedHeads.indexOf(child1),
                                              child1,
                                              budgets,
                                              last2Session,
                                              lastSession,
                                              currentSession
                                            )}
                                          </>
                                        );
                                      })}
                                  </>
                                );
                              })}
                          </>
                        );
                      })}

                    {/* {assignedHeads
                          .filter((ah) => ah.type == 1)
                          .map((head, index) => {
                            console.log("abc");
                            return (
                              <>
                                {}
                              </>
                            );
                          })} */}
                  </tbody>
                  <thead>
                    <tr className="w-full h-16 border-gray-300 dark:border-gray-200 border-b py-8">
                      <th className="table-head"> </th>
                      <th className="table-head"> Total</th>
                      <th className="table-head">
                        {" "}
                        {budgets
                          .filter(
                            (p) =>
                              p.academic_session_id == last2Session.id &&
                              p.budget_type == 2
                          )
                          ?.reduce(
                            (partialSum, budget) =>
                              partialSum +
                              (parseInt(budget.receipt_amount) || 0),
                            0
                          )
                          .toFixed(2)}
                      </th>
                      <th className="table-head">
                        {" "}
                        {budgets
                          .filter(
                            (p) =>
                              p.academic_session_id == lastSession.id &&
                              p.budget_type == 0
                          )
                          ?.reduce(
                            (partialSum, budget) =>
                              partialSum +
                              (parseInt(budget.receipt_amount) || 0),
                            0
                          )
                          .toFixed(2)}
                      </th>
                      <th className="table-head">
                        {budgets
                          .filter(
                            (p) =>
                              p.academic_session_id == lastSession.id &&
                              p.budget_type == 1
                          )
                          ?.reduce(
                            (partialSum, budget) =>
                              partialSum +
                              (parseInt(budget.receipt_amount) || 0),
                            0
                          )
                          .toFixed(2)}{" "}
                      </th>
                      <th className="table-head">
                        {" "}
                        {budgets
                          .filter(
                            (p) =>
                              p.academic_session_id == currentSession.id &&
                              p.budget_type == 0
                          )
                          ?.reduce(
                            (partialSum, budget) =>
                              partialSum +
                              (parseInt(budget.receipt_amount) || 0),
                            0
                          )
                          .toFixed(2)}
                      </th>
                    </tr>
                  </thead>
                </table>

                <hr className="m-10" />
                <h1 className="my-5 font-medium text-xl">
                  {" "}
                  Payments Side:
                  <Button
                    classNames="float-right mr-5 bg-blue-600 hover:bg-blue-700 focus:ring-blue-500"
                    value={"Edit"}
                    onClick={() => {
                      navigate(
                        `/budget-edit/payment/${costCenter_id}/${accBudgetFormId}`
                      );
                    }}
                    icon={"PencilIcon"}
                    type="button"
                  />
                  <Button
                    classNames="float-right mr-5 bg-blue-600 hover:bg-blue-700 focus:ring-blue-500"
                    value={"Download CSV"}
                    onClick={() => tableToCSV("datatablePayment")}
                    icon={"DownloadIcon"}
                    type="button"
                  />
                </h1>
                <table
                  id="datatablePayment"
                  className="min-w-full mt-5 bg-white dark:bg-gray-800"
                >
                  <thead>
                    <tr className="w-full h-16 border-gray-300 dark:border-gray-200 border-b py-8">
                      <th className="table-head"> Ledger Code</th>
                      <th className="table-head"> Heads</th>
                      <th className="table-head">
                        {" "}
                        Actual{" "}
                        {
                          academicSessions.find((as) => {
                            return as.serial == currentSession?.serial - 2;
                          })?.label
                        }{" "}
                        <small className="text-gray-400 text-xs">
                          <br />
                          Amount in Rs.
                        </small>{" "}
                      </th>
                      <th className="table-head">
                        {" "}
                        Budget{" "}
                        {
                          academicSessions.find((as) => {
                            return as.serial == currentSession?.serial - 1;
                          })?.label
                        }{" "}
                        <small className="text-gray-400 text-xs">
                          <br />
                          Amount in Rs.
                        </small>{" "}
                      </th>
                      <th className="table-head">
                        {" "}
                        Revised{" "}
                        {
                          academicSessions.find((as) => {
                            return as.serial == currentSession?.serial - 1;
                          })?.label
                        }{" "}
                        <small className="text-gray-400 text-xs">
                          <br />
                          Amount in Rs.
                        </small>
                      </th>
                      <th className="table-head">
                        {" "}
                        Budget {currentSession?.label}{" "}
                        <small className="text-gray-400 text-xs">
                          <br />
                          Amount in Rs.
                        </small>{" "}
                      </th>
                      <th className="table-head"> Justification </th>
                    </tr>
                  </thead>

                  <tbody>
                    {assignedHeads
                      .filter(
                        (ah) => ah.acc_payment_head_id == null && ah.type == 2
                      )
                      ?.map((head) => {
                        return (
                          <>
                            {assignedHeads.some(
                              (detail1) =>
                                detail1.acc_payment_head_id == head.id
                            ) ? (
                              <tr className="h-12 border-gray-300 dark:border-gray-200 border-b">
                                <td className="font-bold table-data">
                                  {head.code}
                                </td>
                                <td
                                  colSpan="6"
                                  className="font-bold table-data"
                                >
                                  {head.name}
                                </td>
                              </tr>
                            ) : (
                              dataRowPayment(
                                assignedHeads.indexOf(head),
                                head,
                                budgets,
                                last2Session,
                                lastSession,
                                currentSession
                              )
                            )}

                            {assignedHeads
                              .filter(
                                (detail1) =>
                                  detail1.acc_payment_head_id == head.id
                              )
                              ?.map((child) => {
                                return (
                                  <>
                                    {assignedHeads.some(
                                      (detail2) =>
                                        detail2.acc_payment_head_id == child.id
                                    ) ? (
                                      <tr className="h-12 border-gray-300 dark:border-gray-200 border-b">
                                        <td className="font-medium table-data">
                                          {child.code}
                                        </td>
                                        <td
                                          colSpan="6"
                                          className="font-medium table-data"
                                        >
                                          {child.name}
                                        </td>
                                      </tr>
                                    ) : (
                                      dataRowPayment(
                                        assignedHeads.indexOf(child),
                                        child,
                                        budgets,
                                        last2Session,
                                        lastSession,
                                        currentSession
                                      )
                                    )}
                                    {assignedHeads
                                      .filter(
                                        (detail2) =>
                                          detail2.acc_payment_head_id ==
                                          child.id
                                      )
                                      ?.map((child1) => {
                                        return (
                                          <>
                                            {dataRowPayment(
                                              assignedHeads.indexOf(child1),
                                              child1,
                                              budgets,
                                              last2Session,
                                              lastSession,
                                              currentSession
                                            )}
                                          </>
                                        );
                                      })}
                                  </>
                                );
                              })}
                          </>
                        );
                      })}

                    {/* {assignedHeads
                          .filter((ah) => ah.type == 2)
                          ?.map((head, index) => {
                            console.log("abc");
                            return (
                              <>
                                {dataRowPayment(index, head, budgets, last2Session, lastSession, currentSession)}
                              </>
                            );
                          })} */}
                  </tbody>

                  <tfoot>
                    <tr className="w-full h-16 border-gray-300 dark:border-gray-200 border-b py-8">
                      <th className="table-head"> </th>
                      <th className="table-head"> Total</th>
                      <th className="table-head">
                        {" "}
                        {budgets
                          .filter(
                            (p) =>
                              p.academic_session_id == last2Session.id &&
                              p.budget_type == 2
                          )
                          ?.reduce(
                            (partialSum, budget) =>
                              partialSum +
                              (parseInt(budget.payment_amount) || 0),
                            0
                          )
                          .toFixed(2)}
                      </th>
                      <th className="table-head">
                        {budgets
                          .filter(
                            (p) =>
                              p.academic_session_id == lastSession.id &&
                              p.budget_type == 0
                          )
                          ?.reduce(
                            (partialSum, budget) =>
                              partialSum +
                              (parseInt(budget.payment_amount) || 0),
                            0
                          )
                          .toFixed(2)}{" "}
                      </th>
                      <th className="table-head">
                        {budgets
                          .filter(
                            (p) =>
                              p.academic_session_id == lastSession.id &&
                              p.budget_type == 1
                          )
                          ?.reduce(
                            (partialSum, budget) =>
                              partialSum +
                              (parseInt(budget.payment_amount) || 0),
                            0
                          )
                          .toFixed(2)}{" "}
                      </th>
                      <th className="table-head">
                        {" "}
                        {budgets
                          .filter(
                            (p) =>
                              p.academic_session_id == currentSession.id &&
                              p.budget_type == 0
                          )
                          ?.reduce(
                            (partialSum, budget) =>
                              partialSum +
                              (parseInt(budget.payment_amount) || 0),
                            0
                          )
                          .toFixed(2)}{" "}
                      </th>
                      <th className="table-head"> </th>
                    </tr>
                    <tr className="w-full h-16 border-gray-300 dark:border-gray-200 border-b py-8">
                      <th className="table-head"> </th>
                      <th className="table-head"> Surplus/Deficit</th>
                      <th className="table-head">
                        {" "}
                        {(
                          budgets
                            .filter(
                              (p) =>
                                p.academic_session_id == last2Session.id &&
                                p.budget_type == 2
                            )
                            ?.reduce(
                              (partialSum, budget) =>
                                partialSum +
                                (parseInt(budget.receipt_amount) || 0),
                              0
                            ) -
                          budgets
                            .filter(
                              (p) =>
                                p.academic_session_id == last2Session.id &&
                                p.budget_type == 2
                            )
                            ?.reduce(
                              (partialSum, budget) =>
                                partialSum +
                                (parseInt(budget.payment_amount) || 0),
                              0
                            )
                        ).toFixed(2)}
                      </th>
                      <th className="table-head">
                        {" "}
                        {(
                          budgets
                            .filter(
                              (p) =>
                                p.academic_session_id == lastSession.id &&
                                p.budget_type == 0
                            )
                            ?.reduce(
                              (partialSum, budget) =>
                                partialSum +
                                (parseInt(budget.receipt_amount) || 0),
                              0
                            ) -
                          budgets
                            .filter(
                              (p) =>
                                p.academic_session_id == lastSession.id &&
                                p.budget_type == 0
                            )
                            ?.reduce(
                              (partialSum, budget) =>
                                partialSum +
                                (parseInt(budget.payment_amount) || 0),
                              0
                            )
                        ).toFixed(2)}
                      </th>
                      <th className="table-head">
                        {" "}
                        {(
                          budgets
                            .filter(
                              (p) =>
                                p.academic_session_id == lastSession.id &&
                                p.budget_type == 1
                            )
                            ?.reduce(
                              (partialSum, budget) =>
                                partialSum +
                                (parseInt(budget.receipt_amount) || 0),
                              0
                            ) -
                          budgets
                            .filter(
                              (p) =>
                                p.academic_session_id == lastSession.id &&
                                p.budget_type == 1
                            )
                            ?.reduce(
                              (partialSum, budget) =>
                                partialSum +
                                (parseInt(budget.payment_amount) || 0),
                              0
                            )
                        ).toFixed(2)}{" "}
                      </th>
                      <th className="table-head">
                        {" "}
                        {(
                          budgets
                            .filter(
                              (p) =>
                                p.academic_session_id == currentSession.id &&
                                p.budget_type == 0
                            )
                            ?.reduce(
                              (partialSum, budget) =>
                                partialSum +
                                (parseInt(budget.receipt_amount) || 0),
                              0
                            ) -
                          budgets
                            .filter(
                              (p) =>
                                p.academic_session_id == currentSession.id &&
                                p.budget_type == 0
                            )
                            ?.reduce(
                              (partialSum, budget) =>
                                partialSum +
                                (parseInt(budget.payment_amount) || 0),
                              0
                            )
                        ).toFixed(2)}
                      </th>
                      <th className="table-head"> </th>
                    </tr>
                  </tfoot>
                </table>
              </>
            )}

            <br />
          </div>
        </div>
      </div>
    </>
  );
}
function dataRowPayment(
  index,
  head,
  budgets,
  last2Session,
  lastSession,
  currentSession
) {
  return (
    <tr
      key={index}
      className="h-12 border-gray-300 dark:border-gray-200 border-b"
    >
      <td className="table-data">{head.code}</td>
      <td className="table-data">{head.name}</td>
      <td className="table-data">
        {budgets
          .find(
            (p) =>
              p.acc_payment_head_id == head.id &&
              p.academic_session_id == last2Session.id &&
              p.budget_type == 2
          )
          ?.payment_amount?.toFixed(2)}
      </td>
      <td className="table-data">
        {budgets
          .find(
            (p) =>
              p.acc_payment_head_id == head.id &&
              p.academic_session_id == lastSession.id &&
              p.budget_type == 0
          )
          ?.payment_amount?.toFixed(2)}
      </td>
      <td className="table-data">
        {budgets
          .find(
            (p) =>
              p.acc_payment_head_id == head.id &&
              p.academic_session_id == lastSession.id &&
              p.budget_type == 1
          )
          ?.payment_amount?.toFixed(2)}
      </td>
      <td className="table-data">
        {budgets
          .find(
            (p) =>
              p.acc_payment_head_id == head.id &&
              p.academic_session_id == currentSession.id &&
              p.budget_type == 0
          )
          ?.payment_amount?.toFixed(2)}
      </td>
      <td className="table-data">
        {budgets.find((p) => p.acc_payment_head_id == head.id)?.justification}
      </td>
    </tr>
  );
}

function dataRowReceipt(
  index,
  head,
  budgets,
  last2Session,
  lastSession,
  currentSession
) {
  return (
    <tr
      key={index}
      className="h-12 border-gray-300 dark:border-gray-200 border-b"
    >
      <td className="table-data">{head.code}</td>
      <td className="table-data">{head.name}</td>
      <td className="table-data">
        {budgets
          .find(
            (p) =>
              p.acc_payment_head_id == head.id &&
              p.academic_session_id == last2Session.id &&
              p.budget_type == 2
          )
          ?.receipt_amount?.toFixed(2)}
      </td>
      <td className="table-data">
        {budgets
          .find(
            (p) =>
              p.acc_payment_head_id == head.id &&
              p.academic_session_id == lastSession.id &&
              p.budget_type == 0
          )
          ?.receipt_amount?.toFixed(2)}
      </td>
      <td className="table-data">
        {budgets
          .find(
            (p) =>
              p.acc_payment_head_id == head.id &&
              p.academic_session_id == lastSession.id &&
              p.budget_type == 1
          )
          ?.receipt_amount?.toFixed(2)}
      </td>
      <td className="table-data">
        {budgets
          .find(
            (p) =>
              p.acc_payment_head_id == head.id &&
              p.academic_session_id == currentSession.id &&
              p.budget_type == 0
          )
          ?.receipt_amount?.toFixed(2)}
      </td>
    </tr>
  );
}
